import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';

export interface IFormulaireProps {
    valueF: any;
    setValueF: any;
    description: any;
    setDescription: any;
}

const Formulaire = (props: IFormulaireProps) => {


    const {
        valueF, setValueF,
        description,
        setDescription
    } = props


    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Fonctionnalité"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueF"
                        value={valueF}
                        onChange={(e) => setValueF(e.target.value)}
                    />
                </Grid>

                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Description"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
export default Formulaire;
